/**
 * Owner: Haselton Baker Risk Group, LLC
 * Copyright All Rights Reserved
 */
// @flow

import type { Element } from 'react';

import React from 'react';
import { Link } from 'react-router-dom';
import { Badge } from 'reactstrap';
import trim from 'lodash/fp/trim.js';
import isEmpty from 'lodash/fp/isEmpty.js';

type Props = {|
  original: {
    itemKey: string,
    edpKey: string,
    name: string,
    errorCount: number,
  },
|};

const LinkCell = (props: Props): Element<'div'> => {
  const {
    original: { itemKey, name, errorCount },
  } = props;

  const displayName = isEmpty(trim(name)) ? 'Unnamed' : name;

  return (
    <div className="text-wrap">
      <div className="float-left">
        <Link id={`itemKey-${itemKey}`} to={`edit/${itemKey}`}>
          <span className="pr-2">{displayName}</span>
        </Link>
      </div>
      {errorCount > 0 && (
        <div className="float-left">
          <Badge color="danger">{errorCount}</Badge>
        </div>
      )}
    </div>
  );
};

export default LinkCell;
